
const DOCUMENT_MIME_TYPES = [
    'application/zip',
    'application/x-zip-compressed',
    'application/gzip',
    'application/vnd.rar',
    'application/x-7z-compressed',
    'application/epub+zip',
    'application/vnd.amazon.ebook',
    'application/rtf',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/csv',
    'text/html',
    'text/xml',
];

const DOCUMENT_EXTENSIONS = [
    'zip',
    'gz',
    'rar',
    '7z',
    'epub',
    'azw',
    'rtf',
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'csv',
    'html',
    'xml',
];

const DOCUMENT_MAX_SIZE = 50 * 1024 * 1024;

export {
    DOCUMENT_MIME_TYPES,
    DOCUMENT_EXTENSIONS,
    DOCUMENT_MAX_SIZE,
};
